import type { ValidationErrors } from '../../../../../utils/validation';
import { translateKey } from '../../../../../translate';
import { BmiText } from '../../../../elements/BmiText';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroup } from '../../../../elements/forms/HorizontalFormGroup';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { NumberInput } from '../../../../fields/Number';

interface ICustomControlData {
    gewicht: number | null;
    lengte: number | null;
}

interface IBmiAddEditProps {
    customControlData: ICustomControlData;
    errors: ValidationErrors;
    required?: boolean;
}

export function BmiAddEdit(props: IBmiAddEditProps) {
    return (
        <HorizontalFormGroup
            hasErrors={props.errors.has('customControlData.gewicht') || props.errors.has('customControlData.lengte')}
        >
            <FormLabel isRequired={props.required}>BMI</FormLabel>
            <InputContainer size="auto">
                <NumberInput
                    automation="bmiWeight"
                    error={props.errors.get('customControlData.gewicht')}
                    fieldKey="gewicht"
                    placeholder={translateKey('common.weight')}
                    text="kg"
                    textStyle={{ fontWeight: 'bold' }}
                    width="medium"
                />
            </InputContainer>
            <InputContainer size="auto">
                <NumberInput
                    automation="bmiLength"
                    error={props.errors.get('customControlData.lengte')}
                    fieldKey="lengte"
                    placeholder={translateKey('common.length')}
                    text="cm"
                    textStyle={{ fontWeight: 'bold' }}
                    width="medium"
                />
            </InputContainer>
            <InputContainer size="small">
                <BmiText
                    length={props.customControlData.lengte}
                    weight={props.customControlData.gewicht}
                />
            </InputContainer>
        </HorizontalFormGroup>
    );
}
